import { render, staticRenderFns } from "./DeliveryDetailsDialog.vue?vue&type=template&id=503fffd5&scoped=true"
import script from "./DeliveryDetailsDialog.vue?vue&type=script&lang=js"
export * from "./DeliveryDetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./DeliveryDetailsDialog.vue?vue&type=style&index=0&id=503fffd5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503fffd5",
  null
  
)

export default component.exports